import { render, staticRenderFns } from "./ReservationsNew.vue?vue&type=template&id=0a205da3&scoped=true"
import script from "./ReservationsNew.vue?vue&type=script&lang=js"
export * from "./ReservationsNew.vue?vue&type=script&lang=js"
import style0 from "./ReservationsNew.vue?vue&type=style&index=0&id=0a205da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a205da3",
  null
  
)

export default component.exports